import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";
import "./axxess-takeover.scss";
import { UsersService } from "../../services/users-service";
import { IEnumResponse } from "../../interfaces/i-enum";

@autoinject
export class AxxessTakeover {
    private readonly _dialogController: DialogController;
    private readonly _usersService: UsersService;
    public url: string = "";
    public imageUrl: string = "";
    public showCloseButton: boolean = true;
    public name: string;
    public flag: number;

    public constructor(dialogController: DialogController, usersService: UsersService, ) {
        this._dialogController = dialogController;
        this._usersService = usersService;
    }

    public activate(params: IEnumResponse) {
        this.name = params.name;
        this.flag = Number(params.value);
        let takeOverObj = takeOverScreenData.find(x => x.name === params.name);
        this.url = takeOverObj.url,
        this.imageUrl = this.getUrl(takeOverObj.imageName);
    }

    public getUrl(name: string) {
        return require(`../../assets/images/${name}`);
    }

    public closeDialogBox() {
        window.open(this.url);
        this._dialogController.close(true);
    }

    public closeWithoutRerouting() {
        this._dialogController.close(true);
    }

    public async canDeactivate() {
        try {
            await this._usersService.updateTakeoverShown({takeOverScreenFlag: this.flag});
        } catch (error) {
            console.error(error);
        }
    }
}

const takeOverScreenData = [
    {
        name: "Axxess Intelligence",
        url: "https://www.axxess.com/help/axxesshospice/axxess-intelligence/",
        imageName: "ai-takeover.png",
    },
    {
        name: "Agile",
        url: "https://www.axxess.com/agile/",
        imageName: "agile-takeover-2025.jpg",
    },
    {
        name: "Hope",
        url: "https://www.axxess.com/help/axxesshospice/hope/hope-solution-faqs/",
        imageName: "hope-page-takeover.jpg",
    }
];
